<template>
  <div class="plot-edit-page" :key="$route.fullPath">
    <plot-edit v-if="plot" :novel-id="novelId" :plots="plot" :plotId="effectivePlotId" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PlotEdit from "@/components/organisms/PlotEdit.vue";
import { Plot, SubPlot } from "@/lib/models/plot";
import clone from "lodash/cloneDeep";
import { isOverallPlotRouteId } from "@/lib/utils/deepLink";

export default Vue.extend<Data, Methods, Computed, Props>({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  components: { PlotEdit },
  props: {
    novelId: String,
    plotId: String,
  },
  async created() {
    await this.$store.dispatch("plotModule/initialize", this.novelId);
  },
  computed: {
    plot() {
      const { $store, plotId } = this;

      if (!isOverallPlotRouteId(plotId)) {
        return clone($store.getters["plotModule/subPlot"](plotId));
      }
      return clone($store.getters["plotModule/plots"]);
    },
    effectivePlotId() {
      return isOverallPlotRouteId(this.plotId) ? undefined : this.plotId;
    },
  },
  watch: {
    $route: {
      handler() {
        // 同一コンポーネント内でルート変更時にスクロール位置をリセット
        this.$nextTick(() => {
          const mainElement = document.querySelector(".main");
          if (mainElement) {
            mainElement.scrollTop = 0;
          }
        });
      },
      immediate: true,
    },
  },
});

interface Props {
  novelId: string;
  plotId?: string;
}

interface Data {}

interface Computed {
  plot: Plot | SubPlot | null;
  effectivePlotId: string | undefined;
}

interface Methods {}
</script>
